import * as FiIcons from 'react-icons/fi';

const {
  FiHome,
  FiMonitor,
  FiFileText,
  FiGlobe,
  FiUserCheck,
  FiBriefcase,
  FiHeart,
  FiUsers,
  FiTruck
} = FiIcons;

export const serviceCards = [
  {
    name: 'Mobile Notary',
    href: '/services/mobile-notary',
    icon: FiHome,
    description: 'Convenient notarization at your home, office, hospital, or wherever works for you.'
  },
  {
    name: 'Remote Online Notary',
    href: '/services/remote-online-notary',
    icon: FiMonitor,
    description: 'Complete your notarization from anywhere with a secure live video session.'
  },
  {
    name: 'General Notarizations',
    href: '/services/general-notarizations',
    icon: FiFileText,
    description: 'Acknowledgments, jurats, affidavits, powers of attorney, and more.'
  },
  {
    name: 'Apostille Services',
    href: '/services/apostille',
    icon: FiGlobe,
    description: 'A complete document apostille process for paperwork heading abroad.'
  },
  {
    name: 'I-9 Employment Verification',
    href: '/services/i-9-employment-verification',
    icon: FiUserCheck,
    description: 'In-person employment eligibility verification for new and remote hires.'
  },
  {
    name: 'Business & Corporate Documents',
    href: '/services/business-corporate',
    icon: FiBriefcase,
    description: 'Professional notarization for resolutions, agreements, and business letters.'
  },
  {
    name: 'Medical & Healthcare',
    href: '/services/medical-healthcare',
    icon: FiHeart,
    description: 'Discreet notarization for healthcare proxies, directives, and consent forms.'
  },
  {
    name: 'Family & Estate Planning',
    href: '/services/family-estate-planning',
    icon: FiUsers,
    description: 'Patient, detail-oriented support for estate and family documents.'
  },
  {
    name: 'Vehicle Documents',
    href: '/services/vehicle-documents',
    icon: FiTruck,
    description: 'Fast notarization for titles, MVA forms, and private-party transactions.'
  }
];

export const serviceDetails = {
  'mobile-notary': {
    eyebrow: 'MOBILE NOTARY',
    name: 'Mobile Notary',
    subhead: "We come to your home, office, hospital, or wherever works for you. Bring your ID, we'll bring everything else.",
    portuguese: 'Notário Móvel',
    covers: [
      'Powers of attorney',
      'Affidavits and sworn statements',
      'Real estate deed signings (single documents only, not closings)',
      'General acknowledgments'
    ],
    faqs: [
      {
        question: 'Where can you meet me?',
        answer: 'Home, office, hospital, nursing home, coffee shop, wherever is convenient and safe.'
      },
      {
        question: 'How much does it cost?',
        answer: 'Use our exact cost estimator at /services/notary.',
        link: '/services/notary'
      }
    ],
    title: 'Mobile Notary Services | Pronto Notary | Maryland',
    description: 'Mobile notary appointments at your home, office, hospital, or another convenient location across Maryland.'
  },
  'remote-online-notary': {
    eyebrow: 'REMOTE ONLINE NOTARY',
    name: 'Remote Online Notary',
    subhead: 'Notarize from anywhere with a live video call. Maryland-authorized, available worldwide.',
    portuguese: 'Notário Online',
    pricing: '$30 per signature, the Maryland-regulated maximum for Remote Online Notarization. If the notary platform charges its own separate technology fee, that will be shown to you before your appointment and is not part of our fee.',
    covers: [
      'Documents requiring remote online notarization',
      'Signers located anywhere in the world',
      'Live video identity verification',
      'Maryland-authorized online notarizations'
    ],
    faqs: [
      {
        question: 'Is Remote Online Notary legally valid?',
        answer: 'Yes, Maryland authorizes RON, and documents notarized this way are accepted by banks, courts, and most institutions.'
      },
      {
        question: 'What do I need for a remote session?',
        answer: 'A valid government-issued photo ID, a device with a camera, and a stable internet connection.'
      },
      {
        question: 'Can I use this from outside Maryland?',
        answer: 'Yes, as long as Carlos is physically in Maryland during the session, the signer can be anywhere.'
      }
    ],
    title: 'Remote Online Notary | Pronto Notary | Maryland',
    description: 'Maryland-authorized Remote Online Notary services with secure live video appointments available worldwide.'
  },
  'general-notarizations': {
    eyebrow: 'GENERAL NOTARIZATIONS',
    name: 'General Notarizations',
    subhead: 'Powers of attorney, affidavits, sworn statements, parental consents, and everything in between.',
    portuguese: 'Reconhecimento de Firma',
    covers: [
      'Acknowledgments',
      'Jurats',
      'Oaths and affirmations',
      'Sworn statements',
      'Parental travel consent forms',
      'General document witnessing'
    ],
    faqs: [
      {
        question: "What's the difference between an acknowledgment and a jurat?",
        answer: 'An acknowledgment confirms you signed willingly, a jurat requires you to swear the contents are true.'
      },
      {
        question: 'Do I need to sign in front of you?',
        answer: 'Yes, always, never sign beforehand.'
      }
    ],
    title: 'General Notarizations | Pronto Notary | Maryland',
    description: 'General notary services for acknowledgments, jurats, affidavits, powers of attorney, and more in Maryland.'
  },
  'i-9-employment-verification': {
    eyebrow: 'I-9 EMPLOYMENT VERIFICATION',
    name: 'I-9 Employment Verification',
    subhead: 'Every new hire needs their ID checked in person, even for remote teams. Carlos meets your new employee, verifies their documents, and completes Section 2 of the Form I-9 as your authorized representative.',
    portuguese: 'Verificação I-9 de Emprego',
    covers: [
      'I-9 eligibility verification',
      'Remote hire document inspection',
      'New employee onboarding paperwork',
      'Employer authorization letters'
    ],
    faqs: [
      {
        question: 'Do you offer I-9 verification for remote employees?',
        answer: 'Yes, if your company has hired someone in our service area, we can meet them in person to complete the I-9 process on your behalf.'
      },
      {
        question: 'Who is legally responsible for the I-9?',
        answer: 'The employer remains responsible for compliance, Carlos acts as an authorized representative to complete the in-person verification step only.'
      }
    ],
    title: 'I-9 Employment Verification | Pronto Notary | Maryland',
    description: 'In-person I-9 employment verification for new hires and remote teams across Maryland.'
  },
  'business-corporate': {
    eyebrow: 'BUSINESS & CORPORATE DOCUMENTS',
    name: 'Business & Corporate Documents',
    subhead: 'Corporate resolutions, business agreements, and authorization letters, notarized on-site or at your office.',
    covers: [
      'Corporate resolutions',
      'Business agreements',
      'Authorization letters',
      'General business document notarization'
    ],
    faqs: [
      {
        question: 'Can you come to our office?',
        answer: 'Yes, we meet clients at their place of business.'
      },
      {
        question: 'Do you handle multiple signers at once?',
        answer: 'Yes, as long as each signer is present with valid ID.'
      }
    ],
    title: 'Business & Corporate Notary | Pronto Notary | Maryland',
    description: 'On-site notarization for Maryland business resolutions, agreements, authorization letters, and corporate documents.'
  },
  'medical-healthcare': {
    eyebrow: 'MEDICAL & HEALTHCARE',
    name: 'Medical & Healthcare',
    subhead: 'Advance directives, healthcare proxies, and medical consent forms, handled with the same discretion and confidentiality as any sensitive legal document.',
    covers: [
      'Healthcare power of attorney',
      'Living wills',
      'Advance directives',
      'HIPAA authorization forms',
      'Hospital consent forms'
    ],
    note: 'A note on hospital visits: if a signer is heavily medicated or unable to understand what they\'re signing, Maryland law requires us to decline the notarization. This protects the signer and keeps the document valid.',
    faqs: [
      {
        question: 'Can you visit a hospital or care facility?',
        answer: 'Yes, we travel to hospitals, nursing homes, and private residences.'
      },
      {
        question: 'Can you explain what my healthcare document means?',
        answer: "No, we're not attorneys and can't interpret document contents or give advice on what to choose, we handle the notarization itself."
      }
    ],
    title: 'Medical & Healthcare Notary | Pronto Notary | Maryland',
    description: 'Discreet Maryland notary services for healthcare powers of attorney, advance directives, and medical consent forms.'
  },
  'family-estate-planning': {
    eyebrow: 'FAMILY & ESTATE PLANNING',
    name: 'Family & Estate Planning',
    subhead: 'Wills, trusts, and powers of attorney, notarized with patience and attention to detail.',
    covers: [
      'Last will and testament witnessing',
      'Living wills',
      'Trust documents',
      'Adoption documents',
      'Custody agreements',
      'Beneficiary designations'
    ],
    faqs: [
      {
        question: 'Can you notarize a will?',
        answer: "We can witness the signing of a will, we don't draft wills or give legal advice on their contents."
      },
      {
        question: 'Do you handle adoption paperwork?',
        answer: 'Yes, we notarize adoption-related documents and supporting forms.'
      }
    ],
    title: 'Family & Estate Planning Notary | Pronto Notary | Maryland',
    description: 'Patient, detail-oriented notary services for Maryland family, estate planning, adoption, and custody documents.'
  },
  'vehicle-documents': {
    eyebrow: 'VEHICLE DOCUMENTS',
    name: 'Vehicle Documents',
    subhead: 'Title transfers, bills of sale, and MVA forms, notarized quickly so your transaction goes through.',
    covers: [
      'Vehicle title transfers',
      'MVA power of attorney for absentee owners',
      'Duplicate title applications',
      'Family transfer affidavits',
      'General bills of sale for private party transactions'
    ],
    faqs: [
      {
        question: 'Do I need a notary to sell my car in Maryland?',
        answer: 'It depends on the specific paperwork involved, some MVA forms require notarization and others don\'t, we can help you figure out what your situation needs.'
      },
      {
        question: 'Can you meet me at the MVA or a dealership?',
        answer: 'Yes, we can meet you wherever the transaction is happening.'
      }
    ],
    title: 'Vehicle Document Notary | Pronto Notary | Maryland',
    description: 'Fast Maryland notary services for vehicle title transfers, MVA forms, and private-party vehicle documents.'
  }
};